import { NavLink, useNavigate } from "react-router-dom";
import "./Navbar.scss";
import userProfile from "../../assets/images/navbar-icons/user-profile.svg";
import bistatechLogo from "assets/images/bistatech-logo.jpg";
import { useEffect } from "react";

const Navbar = () => {
  const navigate = useNavigate();

  useEffect(() => {
    console.log(localStorage.getItem("token"));
    if (localStorage.getItem("token") === null) {
      navigate("/login");
    }
  }, []);

  return (
    <div className="custom-navbar d-print-none">
      <div className="logo-container">
        <NavLink to="/" className="">
          <img className="logo-image" src={bistatechLogo} alt="logo" />
        </NavLink>
      </div>
      <div className="user-profile-container">
        <div className="user-profile">
          <span>بیستاتِک</span>
          <span>- - -</span>
        </div>
        <NavLink to="/user/profile" className="">
          <img
            src={userProfile}
            className="user-profile-image"
            alt="user-proffile"
            // onClick={() => setShowUserProfilePopup(!showUserProfilePopup)}
          />
        </NavLink>
        {/* <div className="user-profile-popup">
          <span>
            ویرایش پروفایل
          </span>
          <span>
            خروج از حساب کاربری
          </span>
        </div> */}
      </div>
      <div className="hamburger-menu-placeholder"></div>
    </div>
  );
};

export default Navbar;
